import React from 'react';
import { RadioProps } from 'antd';

import {
  StyledAntdRadio,
} from './style';

const CVRadio = (props: RadioProps): JSX.Element => ( // eslint-disable-line
  <StyledAntdRadio {...props} />
);

CVRadio.Group = StyledAntdRadio.Group;

export default CVRadio;
